// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'sigma';

export const Component = () => (
  <path d='M21.194 21.17v3.352H4.096l9.195-12.261L4 0h17.194v3.352h-.958V.958H5.964L14.49 12.26 6.06 23.563h14.177v-2.395h.958l-.001.002Z' />
);

export const viewBox = '0 0 25 25';
